import { Link } from 'react-router-dom';
import { Button } from '@mantine/core';
import { IconQrcode } from '@tabler/icons-react';
import { EmptyState } from '@/components/ui';

/** Unknown address. Most people arrive from a QR code, so point them back at it. */
export default function NotFound() {
  return (
    <div className="proc-main">
      <EmptyState
        icon={<IconQrcode size={28} />}
        title="We couldn't find that page"
        action={<Button component={Link} to="/" fullWidth>Find a procedure</Button>}
      >
        Scan the QR code on the equipment again. If it still doesn't open, the code may be old: please let your team leader know.
      </EmptyState>
    </div>
  );
}
